import React, { useEffect, useMemo, useState } from 'react';
import { List, Popover, Modal, ConfirmOptions } from "tea-component";
import { delMenu, moveMenu, updateMenuSort } from '@/pages/dashboard/services/leftMenu';
import { useIntl, useDispatch, getLocale, useSelector } from 'umi';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { BUSINESS_TYPE_MYDASHBOARD } from '@/pages/dashboard/_config/constant';
export default (props: any) => {
  const { item, item: { onclick = '' }, visible, setVisible, referenceElement, menu, setModalInfoState, moveToMenu } = props;
  const hasArrow = item?.dashoboard_list?.length;
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const locale = getLocale();
  // const [visible, setVisible] = useState<boolean>(false);

  const { currentGame } = useSelector(state => {
    // @ts-ignore
    const { currentGame } = state.dashboard;
    return {
      currentGame,
    }
  });

  const orderToMenu = useMemo(() => {
    // 页面收藏目录u_id为空,移动菜单排除u_id为空的情况
    return { ...menu, folder_list: menu?.folder_list?.filter((folder: any) => folder?.u_id !== '') }
  }, [menu]);

  const menuInfo = useMemo(() => {
    const index = (orderToMenu?.folder_list || []).findIndex((folder: any) => {
      return folder && folder?.id === item?.id;
    });
    const isFirst = index === 0;
    const isLast = index === (orderToMenu?.folder_list?.length - 1);
    return {
      index,
      isFirst,
      isLast,
    }
  }, [orderToMenu, item]);

  const { isFirst, isLast } = menuInfo;

  const hancleClickRename = () => {
    setModalInfoState({
      show: true,
      type: 'edit',
      editType: 'folder',
      item: { ...item }
    });
    setVisible(false);
  }

  const hancleClickDel = () => {
    const name = (locale === 'zh-CN' && item?.name_cn) || item?.name_en;
    setVisible(false);
    Modal.confirm({
      message: <div style={{ fontSize: '16px', fontWeight: '400' }}>
        <div style={{ fontWeight: 'bold' }}>
          {formatMessage({ id: 'menu_info_del_1' }) + formatMessage({ id: 'folder' })}?
        </div>
        <div style={{ marginTop: '5px' }}>
          {formatMessage({ id: 'menu_info_del_2' })}
          <span style={{ fontWeight: 'bold' }}>{name}</span> ?
          <span> {formatMessage({ id: 'menu_info_del_3' })}</span>
        </div>
      </div>,
      okText: formatMessage({ id: 'menu_confirm' }),
      cancelText: formatMessage({ id: 'menu_cancel' }),
      onOk: doDelMenu
    } as ConfirmOptions);
  }

  const handleMoveToMenu = (targetId: string) => {
    setVisible(false);
    Modal.confirm({
      message: <div style={{ fontSize: '16px', fontWeight: '400' }}><span>{formatMessage({ id: 'menu_info_move' })}</span></div>,
      okText: formatMessage({ id: 'menu_confirm' }),
      cancelText: formatMessage({ id: 'menu_cancel' }),
      onOk: () => { doMoveMenu(targetId) }
    } as ConfirmOptions);
  }

  // 移动folder
  const doMoveMenu = (targetId: string) => {
    moveMenu({
      id: item.id,
      game_code: currentGame?.game_code,
      target_menu_id: targetId
    }).then(() => {
      dispatch({
        type: 'dashboard/getLeftMenuList',
      });
    }, (err) => {
    }).finally(() => {
    });
  }

  // 删除folder
  const doDelMenu = () => {
    delMenu({
      id: item.id,
      game_code: currentGame?.game_code,
    }).then(() => {
      dispatch({
        type: 'dashboard/getLeftMenuList',
      });
    }, (err) => {
    }).finally(() => {
    });
  }

  // shift up, shift down
  const doUpdateMenuSort = (targetId: string) => {
    updateMenuSort({
      id: item.id,
      target_menu_id: targetId,
      game_code: currentGame?.game_code
    }).then(() => {
      dispatch({
        type: 'dashboard/getLeftMenuList',
      });
    }).catch((err) => {
      console.log(err)
    })
  }

  const handleClickShiiftUP = () => {
    setVisible(false);
    const preDashboard = orderToMenu?.folder_list?.[menuInfo.index - 1];
    if (!preDashboard) {
      return;
    }
    doUpdateMenuSort(preDashboard.id);
  }

  const handleClickShiiftDown = () => {
    setVisible(false);
    const nextDashboard = orderToMenu?.folder_list?.[menuInfo.index + 1];
    if (!nextDashboard) {
      return;
    }
    doUpdateMenuSort(nextDashboard.id);
  }

  useEffect(() => {
    if (visible) {
      dispatch({
        type: "dashboard/save",
        payload: {
          showContentMask: true
        }
      });

      dispatch({
        type: 'home/save',
        payload: {
          showGlobalMask: 'transparent',
        },
      });
    } else {
      dispatch({
        type: "dashboard/save",
        payload: {
          showContentMask: false
        }
      });

      dispatch({
        type: 'home/save',
        payload: {
          showGlobalMask: false,
        },
      });
    }
    // setActiveInfo && setActiveInfo({
    //   id: item?.id,
    //   show: visible,
    // })

    return () => {
      dispatch({
        type: "dashboard/save",
        payload: {
          showContentMask: false
        }
      });

      dispatch({
        type: 'home/save',
        payload: {
          showGlobalMask: false,
        },
      });
    };
  }, [visible]);

  return (
    <>
      {/*<div className={onclick === 'true' ?"left-nav-hd left-nav-newhidden":"left-nav-hd"}>*/}
      {/*  <span className="left-nav-title">{text}</span>*/}
      {/*  {showNew ? <span className="left-nav-notice">NEW</span> : ""}*/}
      {/*</div>*/}
      {onclick === 'true' && <Popover
        referenceElement={referenceElement}
        visible={visible}
        onVisibleChange={val => setVisible(val)}
        placement="right-start"
        placementOffset={hasArrow ? [-10, 56] : [-10, 26]}
        trigger="click"
        overlay={
          <div className='left-nav-exit' onClick={(e) => {
            e.stopPropagation();
            return false;
          }}>
            <List type="option">
              <List.Item onClick={hancleClickRename}><div className='dbd-sub-nav'><SvgIcon type='rename-icon' className='dbd-sub-nav-icon' /><div className="dbd-sub-nav-text" >{formatMessage({ id: 'menu_rename' })}</div></div></List.Item>
              {!item?.dashoboard_list?.length && <List.Item onClick={hancleClickDel}><div className='dbd-sub-nav'><SvgIcon type='trash-can-icon' className='dbd-sub-nav-icon' /><div className="dbd-sub-nav-text" >{formatMessage({ id: 'menu_delete' })}</div></div></List.Item>}
              <Popover
                placement="right-start"
                placementOffset={[0, 8]}
                overlay={<div className='tea-dropdown-box dbd-menu-option'>
                  <List type="option">
                    {(moveToMenu || [])?.map((menu: any) => {
                      return <List.Item
                        disabled={menu?.id === item?.parent_id || menu?.business_type === BUSINESS_TYPE_MYDASHBOARD}
                        key={menu?.id}
                        onClick={() => { handleMoveToMenu(menu?.id) }}>
                        {locale === 'zh-CN' && menu?.name_cn || menu?.name_en}
                      </List.Item>
                    })}
                  </List>
                </div>
                }
              >
                <List.SubMenu label={<div className='dbd-sub-nav'><SvgIcon type='file-move-icon' className='dbd-sub-nav-icon' /><div className="dbd-sub-nav-text" >{formatMessage({ id: 'menu_move_to' })}</div></div>}></List.SubMenu>
              </Popover>
              {/* 分割线 */}
              <List.Item className='tea-list__separate dbd-sub-line' />
              <Popover
                placement="right-start"
                placementOffset={[0, 8]}
                overlay={<div className='tea-dropdown-box'>
                  <List type="option">
                    <List.Item onClick={handleClickShiiftUP} disabled={isFirst}>
                      <div className={`dbd-sub-nav ${isFirst ? 'disabled' : ''}`}><SvgIcon type='rising-arrow-icon' className='dbd-sub-nav-icon' /><div className="dbd-sub-nav-text"> {formatMessage({ id: 'menu_shift_up' })}</div></div>
                    </List.Item>
                    <List.Item onClick={handleClickShiiftDown} disabled={isLast}>
                      <div className={`dbd-sub-nav ${isLast ? 'disabled' : ''}`}><SvgIcon type='down-arrow-icon' className='dbd-sub-nav-icon' /><div className="dbd-sub-nav-text"> {formatMessage({ id: 'menu_shift_down' })}</div></div>
                    </List.Item>
                  </List>
                </div>
                }
              >
                <List.SubMenu label={<div className='dbd-sub-nav'><SvgIcon type='order-icon' className='dbd-sub-nav-icon' /><div className="dbd-sub-nav-text">{formatMessage({ id: 'menu_order' })}</div></div>}></List.SubMenu>
              </Popover>
            </List>
          </div>
        }
      >
        {/*<span*/}
        {/*  className={hasArrow ? 'left-nav-absolute left-nav-mr' : 'left-nav-absolute'}*/}
        {/*  onClick={(e) => {*/}
        {/*    e.stopPropagation();*/}
        {/*    return false;*/}
        {/*  }}>*/}
        {/*  <SvgIcon type="more" />*/}
        {/*</span>*/}
      </Popover>}
    </>
  );
}
